<template>
    <div>
        
    </div>
</template>

<script>
export default {
    name: 'ScheduleSetup',
    props: {
        handymanId: {
            type: Number,
            required: true
        },
        scheduleData: {
            type: Object,
            required: true
        }
    }
}
</script>